import * as React from 'react';
import { CustomerModal, newCustomer } from '../Modal/CustomerModal';
import { CustomerInterface } from '../../Interfaces/CustomerInterface';
import { Button, ButtonType } from '../common/Button/Button';
import './CustomerDetails.scss';
import { l } from '../../Other/Translation';


export interface CustomerInfoProps {
  customer: CustomerInterface;
  saveCustomer: (customer) => void;
}

const CustomerAddress = ({ address }) => {
  const city = address.city || address.pobox ? `${address.pobox || ''} ${address.city || ''}` : null;
  return <div className={'address'}>
    <div className={'row'}>{address.streetAddress1}</div>
    {address.streetAddress2 && <div className={'row'}>{address.streetAddress2}</div>}
    {city && <div className={'row'}>{city}</div>}
  </div>;
};

const keys = {
  header: 'Customer',
  addCustomer: 'AddCustomerDetails',
  editCustomer: 'Edit',
  vatNumber: 'VATnumber'
};

export const CustomerDetails: React.FunctionComponent<CustomerInfoProps> = ({ customer, saveCustomer }) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  return (
    <div className={'CustomerDetails'}>
      <CustomerModal
        isOpen={isModalOpen}
        customer={customer || newCustomer}
        saveCustomer={(customer) => saveCustomer(customer)}
        close={() => setModalOpen(false)}
      />
      <div className={'CustomerHeader'}>{l(keys.header)}</div>
      {customer ?
        <div className={'CustomerInfo'}>
          {customer.companyName && <div className={'companyName'}>{customer.companyName}</div>}
          {(customer.firstName || customer.lastName) && <div className={'row'}>{customer.firstName} {customer.lastName}</div>}
          {customer.address && <CustomerAddress address={customer.address} />}
          {customer.vatNumber && <div className={'row'}>{customer.vatNumber}</div>}
          <Button
            type={ButtonType.link}
            label={l(keys.editCustomer)}
            action={() => setModalOpen(true)}
          />
        </div>
        :
        <div className={'CustomerAdd'}>
          <Button
            type={ButtonType.link}
            label={l(keys.addCustomer)}
            action={() => setModalOpen(true)}
          />
        </div>
      }
    </div>
  );
}
